import { defineComponent as _defineComponent } from 'vue'
import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import HeaderTypeA from '@/components/HeaderTypeA.vue';
import HeaderTypeB from '@/components/HeaderTypeB.vue';
import HeaderTypeC from '@/components/HeaderTypeC.vue';
import HeaderTypeD from '@/components/HeaderTypeD.vue';
import Footer from '@/components/Footer.vue';
import NavBar from '@/components/NavBar.vue';
import Toasts from '@/components/Toasts.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const headerTitle = computed(() => {
  if (route.name === null) return '';
  return (route.meta.headerTitle as string | undefined) || '';
});
const spHeaderBackLink = computed(() => {
  return route.meta.spHeaderBackLink as boolean;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.name === null || _ctx.$route.meta.header === 'none')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
      : (_unref(route).meta.header === 'typeA')
        ? (_openBlock(), _createBlock(HeaderTypeA, {
            key: 1,
            title: _unref(headerTitle)
          }, null, 8, ["title"]))
        : (_unref(route).meta.header === 'typeB')
          ? (_openBlock(), _createBlock(HeaderTypeB, {
              key: 2,
              title: _unref(headerTitle)
            }, null, 8, ["title"]))
          : (_unref(route).meta.header === 'typeC')
            ? (_openBlock(), _createBlock(HeaderTypeC, {
                key: 3,
                spHeaderBackLink: _unref(spHeaderBackLink),
                title: _unref(headerTitle)
              }, null, 8, ["spHeaderBackLink", "title"]))
            : (_unref(route).meta.header === 'typeD')
              ? (_openBlock(), _createBlock(HeaderTypeD, { key: 4 }))
              : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_unref(route).meta.footer)
      ? (_openBlock(), _createBlock(Footer, { key: 5 }))
      : _createCommentVNode("", true),
    (_unref(route).meta.navBar)
      ? (_openBlock(), _createBlock(NavBar, { key: 6 }))
      : _createCommentVNode("", true),
    _createVNode(Toasts)
  ], 64))
}
}

})